// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers, ResponseContentType } from '@angular/http';
import { WeeklyNews } from '../../model/weeklynews';
import { Observable } from 'rxjs/Rx';
import { GlobalServiceProvider } from '../../providers';
/*
  Generated class for the WeeklyNewsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WeeklyNewsProvider {
  baseUrl: string;
  pageLimit: Number = 10;
  constructor(public http: Http, public globalService: GlobalServiceProvider) {
    // console.log('Hello WeeklyNewsProvider Provider');
    this.baseUrl = this.globalService.appConfig.BaseApiTmsUrl;
  }

  weeklynews: any = null;

  get getWeeklynews():any {
      return this.weeklynews;
  }
  
  set setWeeklynews(valueObj:any) {
      this.weeklynews = valueObj;
  }

  getWeeklyNewsV2(filter, condition): Observable<WeeklyNews[]> {
    return this.http.get(this.baseUrl + '/weeklyNewsCus/', { params: { filter: filter, condition: condition } })
      .map((res) => res.json().map(item => {
        return new WeeklyNews(item);
      }))
      .catch((error) => Observable.throw(error || 'Server error'));
  }

  updateWeeklyNews(id,data) {
    let url = this.baseUrl + '/weeklyNewsCus/'+id;
    return this.http.put(url, data)
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getDownloadFileById(fileId) {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.ArrayBuffer
    });

    return this.http
      .get(this.baseUrl + '/public/downloadfile/' + fileId, options)
      .toPromise()
      .then((data) => {
          return data.arrayBuffer()
      })
      .catch(
          err => {
              return null;
          }
      );
  }


  increaseLike(id, data) {
    let url = this.baseUrl + '/weeklyNewsCus/increaselike/' + id;
    return this.http.put(url, data)
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  descreaseLike(id, data) {
    let url = this.baseUrl + '/weeklyNewsCus/descreaselike/' + id;
    return this.http.put(url, data)
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  comments(id, data) {
    let url = this.baseUrl + '/weeklyNewsCus/comments/' + id;
    return this.http.put(url, data)
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  reply(id, data) {
    let url = this.baseUrl + '/weeklyNewsCus/reply/' + id;
    return this.http.put(url, data)
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  deleteComments(id, data) {
    let url = this.baseUrl + '/weeklyNewsCus/deletecomments/' + id;
    return this.http.put(url, data)
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  increaseView(id, data) {
    let url = this.baseUrl + '/weeklyNewsCus/viewpage/' + id;
    return this.http.put(url, data)
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }
}





// WEBPACK FOOTER //
// ./src/pages/weekly-news/weekly-news-service.ts